const axios = require('axios');
const gptHost = process.env.REACT_APP_HOST + "/api/v1/gpt/getQuiz";
const gptHost2 = process.env.REACT_APP_HOST + "/api/v1/gpt/getFeedback";
const correctAnswersApi  = process.env.REACT_APP_HOST + "/api/v1/gpt/getCorrectAnswers";
const popQuizApi = process.env.REACT_APP_HOST + "/api/v1/gpt/getPopQuiz";

// Distinct from getQuizQuestions above - that generates I-O-prediction questions tied to
// a specific function. This generates free-form multiple choice questions for a
// standalone Pop Quiz session from a topic/instructions string, for the instructor to
// review/edit before saving with the session.
export async function generatePopQuizQuestions(topic, numQuestions = 5) {
  if (!topic || topic.length === 0) return { questions: [] };

  try {
    const response = await axios.post(popQuizApi, { topic, numQuestions });
    return response.data;
  } catch (error) {
    console.error('Error generating pop quiz questions:', error);
    throw error;
  }
}

export async function getQuizQuestions(taskDescription) {
  if (!taskDescription || taskDescription.length === 0) {
    return []; // Return an empty array if no task description is provided
  }

  try {
    let response = await axios.post(gptHost, {
      taskDescription: taskDescription
    });

    // if (response.data && response.data.length > 0) {
    //     //console.log("response.data[0].quizQuestions:", response.data[0].quizQuestions)
    //     return response.data;
    // }
    return response.data; 
  } catch (error) {
    console.error('Error fetching quiz questions:', error);
    throw error; 
  }
}
export async function getAnswerFeedBack(taskDescription, functionName, wrongAnswers) {
  if (!taskDescription || taskDescription.length === 0 || !functionName || functionName.length === 0 || !wrongAnswers || wrongAnswers.length === 0) {
    return ""; 
  }

  try {
    let response = await axios.post(gptHost2, {
      taskDescription: taskDescription,
      functionName: functionName,
      wrongAnswers: wrongAnswers
    });

    // if (response.data && response.data.length > 0) {
    //     //console.log("response.data[0].quizQuestions:", response.data[0].quizQuestions)
    //     return response.data;
    // }
    //console.log(response.data)
    return response.data; 
  } catch (error) {
    console.error('Error fetching quiz questions:', error);
    throw error; 
  }
}


export async function getCorrectAnswers(taskDescription) {
  if (!taskDescription || taskDescription.length === 0) {
    return []; 
  }
  try {
    let response = await axios.post(correctAnswersApi, {
      taskDescription: taskDescription
    });
    return response.data; 
  } catch (error) {
    console.error('Error fetching quiz questions:', error);
    throw error; 
  }
}
